export default "__VITE_ASSET__CMk1yvPY__"